module.exports = __webpack_public_path__ + "static/media/aboutAwardsSvg.b627c959.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutAwardsSvg.svg
// module id = 1221
// module chunks = 0